export const svgLupe = `<svg width='24' height='20'>
              <circle cx='13' cy='7' r='6.5' fill='#fff8' stroke='#666666'></circle>
              <path d='M9.75 12.629 A6.5 6.5 0 0 1 7.371 10.25' fill='none' stroke='#666666' stroke-width='1.5'></path>
              <line x1='1' y1='19' x2='1.5' y2='18.5' stroke='#666666' stroke-width='2'></line>
              <line x1='1.5' y1='18.5' x2='6' y2='14' stroke='#666666' stroke-width='2.5'></line>
              <line x1='6' y1='14' x2='6.5' y2='13.5' stroke='#666666' stroke-width='2'></line>
              <line x1='6.5' y1='13.5' x2='8.5' y2='11.5' stroke='#666666' stroke-width='1.5'></line>
            </svg>`;
